import { Layout } from "antd";
import { ReactComponent as Close } from "assets/icons/close.svg";
import { ReactComponent as Menu } from "assets/icons/menu.svg";

const { Header } = Layout;

const ChatHeader = ({ goBack, onCollapsedChange }) => {
  return (
    <Header className={`rtl fixed h-auto px-5 w-full py-3 z-40 bg-white`}>
      <div className=" flex justify-between items-center ">
        <div className="cursor-pointer">
          <Close
            onClick={() => goBack()}
            alt="arrow"
            className="[&>path]:stroke-gray-4"
          />
        </div>
        <div className="body-14px-regular ">
          <span className="text-gray-0 ">فیروزه AI</span>
        </div>
        <div className="">
          <Menu onClick={() => onCollapsedChange()} />
        </div>
      </div>
    </Header>
  );
};

export default ChatHeader;
